import type { ProspectFormLockStatus } from '@common/types/formLocks';
import axiosInstance from '@/services/axiosInstance';

export async function getProspectFormLockStatus(
    prospectId: string,
): Promise<ProspectFormLockStatus> {
    const response = await axiosInstance.get<ProspectFormLockStatus>(
        `api/v1/form-locks/prospect/${prospectId}`,
    );
    return response.data;
}
